import React, { useEffect, useState } from 'react';
import { useParams } from 'react-router-dom';
import axios from 'axios';
import {
  Card,
  Typography,
  Form,
  Input,
  Select,
  Button,
  Spin,
  message,
  Popconfirm,
  Switch,
} from 'antd';

const { Title, Text } = Typography;
const { Option } = Select;

const OrganizationDetails = () => {
  const { orgId } = useParams();
  const [organization, setOrganization] = useState(null);
  const [loading, setLoading] = useState(true);
  const [editMode, setEditMode] = useState(false);
  const [formData, setFormData] = useState({});

  useEffect(() => {
    // Fetch organization details
    const fetchOrganization = async () => {
      try {
        const response = await axios.get(
          `${process.env.REACT_APP_API}/api/organizations/${orgId}`
        );
        setOrganization(response.data);
        setFormData(response.data); // Pre-fill the form with fetched data
        setLoading(false);
      } catch (error) {
        console.error('Error fetching organization data:', error);
        setLoading(false);
      }
    };

    fetchOrganization();
  }, [orgId]);


  const toggleStatus = async (currentStatus) => {
    try {
      const response = await axios.patch(
        `${process.env.REACT_APP_API}/api/organizations/${orgId}/toggle-status`,
        {}
      );
      message.success(response.data.message);
      setOrganization((prevOrg) => ({
        ...prevOrg,
        status: currentStatus === 'ACTIVE' ? 'INACTIVE' : 'ACTIVE',
      }));
    } catch (error) {
      console.error('Error toggling organization status:', error);
      message.error('Failed to update organization status');
    }
  };


  const handleSave = async () => {
    try {
      formData.employeeCount=parseInt(formData.employeeCount)
      await axios.patch(
        `${process.env.REACT_APP_API}/api/organizations/${orgId}`,
        formData
      );
      setOrganization(formData); // Update the local state
      setEditMode(false); // Exit edit mode
      message.success('Organization updated successfully.');
    } catch (error) {
      console.error('Error updating organization:', error);
      message.error('Failed to update organization.');
    }
  };

  if (loading) {
    return (
      <div style={{ textAlign: 'center', marginTop: '20%' }}>
        <Spin size="large" />
      </div>
    );
  }

  if (!organization) {
    return (
      <div style={{ textAlign: 'center', marginTop: '20%' }}>
        <Title level={4} type="danger">
          Organization not found.
        </Title>
      </div>
    );
  }

  return (
    <div style={{ padding: '20px' }}>
      <Card
        title={
            <div>   
                 <Title level={3} style={{ margin: 0,color:"white" }}>
            Organization Details
          </Title>
                
                  <div style={{ display: 'flex', alignItems: 'center', gap: '10px' }}>
            <p style={{ color: 'white' }}>
              <strong>Status:</strong>{' '}
            </p>
  
            <Popconfirm
              title={`Are you sure you want to change the status to ${organization.status === 'ACTIVE' ? 'Inactive' : 'Active'}?`}
              onConfirm={() => toggleStatus(organization.status)} // This will trigger the status change if confirmed
              okText="Yes"
              cancelText="No"
            >
              <Switch
                checked={organization.status === 'ACTIVE'}
                checkedChildren="Active"
                unCheckedChildren="Inactive"
              />
            </Popconfirm>
          </div></div>
         

          
        }
        bordered={false}
        style={{
          background: '#141414',
          color: '#fff',
        }}
      >
        {!editMode ? (
          <>
            <p>
              <Text style={{color:"white"}} strong>ID:</Text> {organization.id}
            </p>
            <p>
              <Text style={{color:"white"}} strong>Name:</Text> {organization.name}
            </p>
            <p>
              <Text  style={{color:"white"}} strong>Address:</Text> {organization.address || 'N/A'}
            </p>
            <p>
              <Text style={{color:"white"}} strong>Employee Count:</Text>{' '}
              {organization.employeeCount || 'N/A'}
            </p>
            <Button type="primary" onClick={() => setEditMode(true)}>
              Edit
            </Button>
          </>
        ) : (
          <Form layout="vertical" style={{ color: '#fff' }}>
            <Form.Item label="Name">
              <Input
                value={formData.name}
                onChange={(e) =>
                  setFormData((prev) => ({ ...prev, name: e.target.value }))
                }
              />
            </Form.Item>
            <Form.Item label="Address">
              <Input
                value={formData.address || ''}
                onChange={(e) =>
                  setFormData((prev) => ({ ...prev, address: e.target.value }))
                }
              />
            </Form.Item>
            <Form.Item label="Employee Count">
              <Input
                type="number"
                value={formData.employeeCount || ''}
                onChange={(e) =>
                  setFormData((prev) => ({
                    ...prev,
                    employeeCount: e.target.value,
                  }))
                }
              />
            </Form.Item>
            <Button type="primary" onClick={handleSave} style={{ marginRight: '8px' }}>
              Save
            </Button>
            <Button onClick={() => setEditMode(false)}>Cancel</Button>
          </Form>
        )}
      </Card>
    </div>
  );
};

export default OrganizationDetails;
